import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Edit, ListCheck, CalendarDays, User, Building, Gift, Printer } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import ShimmerLoader from '../../hooks/ShimmerLoader';
import { creatLoyalityAssign, getLoyaltyUserCard, getUserlist, getLoyaltyCardUnAssign } from "../../services/api";
import Pagination from "../../hooks/Pagination";

import toastr from 'toastr';
import Autosuggest from 'react-autosuggest';

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";

import dayjs from "dayjs";
import { DateInput } from "@mantine/dates";


export default function LoyaltyUserCard() {
  useDocumentTitle('Welcome to Admin | Loyalty Card');
  const navigate = useNavigate();
  const [loyalty_card, setLoyaltyCard] = useState([]);
  const [loyaltycardlist, setLoyaltyCardList] = useState([]);
  const [userrlist, setUserlist] = useState([]);
  const [UserTypes, setUserType] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);


  const wrapperRef = useRef(null);
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [suggestionsCard, setSuggestionsCard] = useState([]);
  const [value, setValue] = useState('');

  const perPage = 20;

  const fetchusers = async (keyword = null) => {
    const userIds = loyalty_card.map(item => item.user_id);

    try {
      const response = await getUserlist(25, 1, keyword, userIds);
      const data = await response.data;
      setUserlist(data.data || data);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };

  const fetchLoyaltyCard = async () => {
    try {
      const response = await getLoyaltyCardUnAssign(25, 1);
      const data = await response.data;
      setSuggestionsCard(data.data || data);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };
  const fetchLoyaltyUserCard = async (perPage, currentPage) => {
    try {
      const response = await getLoyaltyUserCard(perPage, currentPage);
      const data = await response.data;

      setLoyaltyCard(data.data || data); // Adjust based on your API response structure
      setCurrentPage(data.current_page);
      setTotalPages(data.last_page);
      setUserType(response.UserType);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {

    // fetchusers()
    fetchLoyaltyCard()
    fetchLoyaltyUserCard(perPage, currentPage);
  }, [currentPage]);

  const initialFormData = {
    is_edit: 0,
    user_id: 0,
    card_id: 0,
    card_number: "",
    status: "active",
    notes: "",
    activation_date: '',
    points_balance: "0",
    is_primary_card: true,
    deactivation_date: '',
  };
  const [edited, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const handleOpen = () => {
    setEdit(false)
    setOpen(!open)
    setQuery('');
    setSelectedItem(null);
    setFormData(initialFormData)
  };
  const handleChange = (e, field = '') => {
    let name = '';
    let value = '';
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = field//field.name;
      value = e;
    }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formData);
    // return false
    toastr.options = {
      closeButton: true,
      progressBar: true,
      timeOut: 3000,
      positionClass: 'toast-top-center'
    };
    if (formData.user_id == '' || formData.user_id == 0) {
      toastr.error('Select cutomer from the list', { timeOut: 2000 });
      return false
    }
    if (formData.card_id == '' || formData.card_id == 0) {
      toastr.error('Select Loyalty Card from the list', { timeOut: 2000 });
      return false
    }
    if (formData.status == '') {
      toastr.error('Select status type', { timeOut: 2000 });
      return false
    }

    try {
      const response = await creatLoyalityAssign(formData);
      if (response.status.success) {
        fetchLoyaltyUserCard(perPage, currentPage);
        setOpen(false)
        toastr.success(response.message)
        setFormData(initialFormData)
        setSuggestions([])
        setSuggestionsCard([])
        setValue('')

      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      // console.error("Error:", error);
      toastr.error("Add Card failed. Please try again.");
    }
  }
  // Close suggestions when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Filter data based on query
  useEffect(() => {
    if (query.length < 2) {
      setSuggestions([]);
      return;
    }
    fetchusers(query)
    setTimeout(function () {
      const searchTerm = query.toLowerCase();
      const filtered = userrlist.filter(item =>
        item.name.toLowerCase().includes(searchTerm) ||
        item.email.toLowerCase().includes(searchTerm) ||
        item.mobile.toLowerCase().includes(searchTerm)
      );
      setSuggestions(filtered);
    }, 1000);

  }, [query]);


  const handleInputChange = (e) => {
    setQuery(e.target.value);
    setShowSuggestions(true);
    setSelectedItem(null);
  };

  const handleSuggestionClick = (item) => {

    setFormData(prev => ({
      ...prev,
      ['user_id']: item.id
    }));
    setSelectedItem(item);
    setQuery(`${item.name} (${item.email})`);
    setShowSuggestions(false);
  };

  const clearSelection = () => {
    setQuery('');
    setSelectedItem(null);
    setShowSuggestions(false);
    setSuggestions([]);
  };

  const handleEdit = ((item) => {
    setQuery(`${item.name} (${item.email})`);
    setSelectedItem(item);
    setValue(`${item.card_number} (${item.card_type})`)
    setFormData({
      is_edit: 1,
      user_id: item.user_id,
      card_id: item.card_id,
      status: item.status,
      card_number: item.card_number,
      notes: item.notes,
      is_primary_card: item.is_primary_card,
      activation_date: (item.activation_date) ? dayjs(item.activation_date).format("YYYY-MM-DD") : '',
      points_balance: item.points_balance,
      deactivation_date: (item.deactivation_date) ? dayjs(item.deactivation_date).format("YYYY-MM-DD") : '',
    });
    setOpen(true)
    setEdit(true)
  })
  const handlePrint = ((item) => {
    navigate("/loyalty/printcard");
  })

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      setSelectedRows(loyalty_card.map(item => item.card_number));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (e, card_number) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedRows([...selectedRows, card_number]);
    } else {
      setSelectedRows(selectedRows.filter(name => name !== card_number));
      setSelectAll(false);
    }
  };

  const PrintCard = () => {
    if (selectedRows.length > 0) {
      let params = selectedRows.join(',')
      window.open(`/loyalty/printcard?${params.toString()}`, '_blank', 'noopener,noreferrer');
    } else {
      alert('No items selected');
    }
  };

  const fetchSuggestions = async ({ value }) => {
    if (!value) return setSuggestionsCard([]);

    try {

      const response = await getLoyaltyCardUnAssign(25, 1, [], value);
      const data = await response.data;
      setSuggestionsCard(data.data || data);
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      setSuggestionsCard([]);
    }
  };

  const onSuggestionsFetchRequested = ({ value }) => fetchSuggestions({ value });
  const onSuggestionsClearRequested = () => setSuggestionsCard([]);

  const getSuggestionValue = suggestion => `${suggestion.program_name} ${suggestion.card_number} (${suggestion.card_type})`;
  const renderSuggestion = suggestion => (
    <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm">
      {suggestion.program_name} {suggestion.card_number} ({suggestion.card_type})
    </div>
  );
  const setSelectedCardId = (card_id) => {
    setFormData(prev => ({
      ...prev,
      ['card_id']: card_id
    }));
  }



  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-4">
      {error && <div style={{ color: 'red' }}>{error}</div>}

      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <form onSubmit={handleSubmit}>
            <div className="bg-white rounded-lg shadow-xl min-w-[300px] w-[60vw] max-w-[900px] max-h-[95vh] flex flex-col">
              <div className="flex justify-between items-center border-b px-6 py-4">
                <h3 className="text-lg font-semibold">Assign Customer</h3>
                <button
                  type="button"
                  onClick={() => setOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="p-4 space-y-4 overflow-y-auto flex-grow">
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Cutomer List</label>
                    <div className="relative">
                      <div className="relative w-full" ref={wrapperRef}>
                        <div className="relative">
                          <input
                            id="search"
                            type="text"
                            value={query}
                            onChange={handleInputChange}
                            onFocus={() => setShowSuggestions(true)}
                            className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                            placeholder="Search by name, email or mobile..."
                            autoComplete="off"
                          />
                          <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                          {query && (
                            <button
                              onClick={clearSelection}
                              className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                              </svg>
                            </button>
                          )}
                        </div>

                        {/* Suggestions dropdown */}
                        {showSuggestions && suggestions.length > 0 && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                            <ul>
                              {suggestions.map((item) => (
                                <li
                                  key={item.id}
                                  onClick={() => handleSuggestionClick(item)}
                                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                                >
                                  <div className="font-medium">{item.name}</div>
                                  <div className="text-sm text-gray-500">{item.email} | {item.mobile}</div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        {/* Selected item details (optional) */}
                        {selectedItem && (
                          <div className="mt-4 p-4 bg-gray-50 rounded-md">
                            <h3 className="font-medium">{selectedItem.name}</h3>
                            <p className="text-gray-600">Email ID: {selectedItem.email}</p>
                            <p className="text-sm text-gray-500">Mobile: {selectedItem.mobile}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="w-full max-w-md mx-auto ">
                    <label className="block text-sm font-medium mb-1">Loyalty Card List</label>
                    <Autosuggest
                      disabled
                      suggestions={suggestionsCard}
                      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                      onSuggestionsClearRequested={onSuggestionsClearRequested}
                      getSuggestionValue={getSuggestionValue}
                      onSuggestionSelected={(_, { suggestion }) => {
                        setSelectedCardId(suggestion.card_id); // Capture the card_id
                      }}
                      renderSuggestion={renderSuggestion}
                      inputProps={{
                        disabled: edited,
                        placeholder: 'Type to search...',
                        value,
                        onChange: (_, { newValue }) => setValue(newValue),
                        className: 'w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500'
                      }}
                      theme={{
                        container: 'relative',
                        suggestionsContainer:
                          'absolute z-50 w-full bg-white border border-gray-200 rounded mt-1 shadow max-h-60 overflow-y-auto',
                        suggestionsList: 'm-0 p-0 list-none',
                        suggestion: '',
                        suggestionHighlighted: 'bg-blue-100'
                      }}
                    />
                  </div>

                  {/* <div>
                    <label className="block text-sm font-medium mb-1">Loyalty Card List</label>
                    <div className="relative">
                      <select disabled={edited} name="card_id" value={formData.card_id || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      >
                        <option value="">Select</option>
                        {loyaltycardlist.map((item) => (
                          <option key={item.card_id} value={item.card_id}>{item.program_name} {item.card_number} ({item.card_type})</option>
                        ))}
                      </select>
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div> */}

                  <div>
                    <label className="block text-sm font-medium mb-1">Points Balance </label>
                    <div className="relative">
                      <input
                        type="text"
                        name="points_balance"
                        value={formData.points_balance || ""}
                        onChange={handleChange}
                        placeholder="Points Balance"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <Gift className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                  <div>
                    <label className="block text-sm font-medium mb-1">Notes </label>
                    <div className="relative">
                      <textarea
                        type="text"
                        name="notes"
                        value={formData.notes || ""}
                        onChange={handleChange}
                        placeholder="notes"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>


                  <div>
                    <label className="block text-sm font-medium mb-1">Status</label>
                    <div className="relative">
                      <select name="status" value={formData.status || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      >
                        <option value="" disabled>Select</option>
                        <option value="active">active</option>
                        <option value="inactive">Inactive</option>
                        <option value="suspended">Suspended</option>
                      </select>
                      <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                    </div>
                  </div>


                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Activation Date</label>
                    <div className="relative">
                      <DateInput
                        valueFormat="DD-MM-YYYY"
                        placeholder="Pick Activation Date"
                        value={formData.activation_date}
                        onChange={(date) => {
                          handleChange(date, 'activation_date');
                          // reset toDate if it's before the new fromDate
                          if (formData.deactivation_date && date && formData.deactivation_date < date) {
                            handleChange(date, 'deactivation_date');//setToDate(null);
                          }
                        }}
                        leftSection={<CalendarDays size={18} className="text-gray-400" />}
                        className="w-full rounded-xl"
                      />
                      {/* <Flatpickr
                        value={formData.activation_date}
                        onChange={([date]) => handleChange(date, 'activation_date')}
                        options={{
                          defaultDate: null,
                          dateFormat: "d/m/Y", // Format: DD/MM/YYYY
                        }}
                        placeholder="Select a Start date"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                      <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} /> */}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Deactivation date</label>
                    <div className="relative">
                      <DateInput
                        valueFormat="DD-MM-YYYY"
                        minDate={formData.activation_date || undefined}
                        placeholder="Pick Deactivation date"
                        value={formData.deactivation_date}
                        onChange={(date) => {
                          handleChange(date, 'deactivation_date');
                        }}
                        leftSection={<CalendarDays size={18} className="text-gray-400" />}
                        className="w-full rounded-xl"
                      />
                      {/* <Flatpickr
                        value={formData.deactivation_date}
                        onChange={([date]) => handleChange(date, 'deactivation_date')}
                        options={{
                          defaultDate: null,
                          dateFormat: "d/m/Y", // Format: DD/MM/YYYY
                        }}
                        name='deactivation_date' id='deactivation_date'
                        placeholder="Select a End date"
                        className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />

                      <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} /> */}
                    </div>
                  </div>
                </div>

              </div>

              <div className="flex justify-end border-t px-6 py-4">
                <button
                  type="submit"
                  className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      <div className="w-full  bg-white shadow-lg rounded-2xl p-6">

        <div className="grid grid-flow-col grid-rows-3 gap-4">
          <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Assign Card To Customer</h2></div>
          {selectedRows.length > 0 && (
            <div className="row-start-1 row-end-4 text-right">
              <button type="button" onClick={PrintCard} className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">Print</button>
            </div>
          )}

          <div className="row-start-1 row-end-4 text-right">
            <button type="button" onClick={handleOpen} className="py-2 px-4  bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors">Assign</button>
          </div>
        </div>

        <div className="overflow-auto">

          <table className="w-full text-sm text-left">
            <thead className="text-gray-700 bg-gray-100">
              <tr>
                <th className="p-3">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out rounded"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                    <span className="ml-2">All</span>
                  </label>
                </th>
                <th className="p-3">Customer ID</th>
                <th className="p-3">Customer Name</th>
                <th className="p-3">Card Number</th>
                <th className="p-3">Card Type</th>
                <th className="p-3">Points Balance</th>
                <th className="p-3">Activation Date</th>
                <th className="p-3">Status</th>
                <th className="p-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loading ? (
                <>
                  <tr>
                    <td className="p-3" colSpan={9}>
                      <ShimmerLoader />
                      <ShimmerLoader />
                      <ShimmerLoader />
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  {loyalty_card.length > 0 ? (
                    loyalty_card.map((item, key) => (
                      <tr key={key}>
                        <td className="p-3">
                          <label className="inline-flex items-center">
                            <input
                              type="checkbox"
                              className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out rounded"
                              checked={selectedRows.includes(item.card_number)}
                              onChange={(e) => handleRowSelect(e, item.card_number)}
                            />
                          </label>
                        </td>
                        <td className="p-3">{item.user_id}</td>
                        <td className="p-3">
                          <div className="inline-flex items-center">
                            {item.UserType == 2 ? (
                              <Building size={25} />
                            ) : (
                              <User size={25} />
                            )}

                            <div>
                              {item.UserType == 2 ? (
                                <strong>{item.name}</strong>
                              ) : (
                                <strong>{item.title}. {item.fname} {item.lname}</strong>
                              )}
                              <div>Type: {UserTypes[item.UserType]}</div>
                            </div>
                          </div>

                        </td>

                        <td className="p-3">{item.card_number}<br />{item.program_name}</td>
                        <td className="p-3">{item.card_type}</td>
                        <td className="p-3">{item.points_balance}</td>
                        <td className="p-3">{item.activation_date}</td>
                        <td className="p-3">{item.status}</td>
                        <td className="p-3 text-center space-x-2">
                          <button onClick={() => handleEdit(item)} className="text-[#f4a406] hover:underline inline-flex items-center gap-1">
                            <Edit size={16} />
                          </button>
                          <button title="Print Card" onClick={() => handlePrint(item)} className="text-[#f4a406] hover:underline inline-flex items-center gap-1">
                            <Printer size={16} />
                          </button>
                          {/* <button className="text-red-500 hover:underline inline-flex items-center gap-1">
                            <Trash2 size={16} />
                          </button> */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="p-3" colSpan={7}>
                        No record found
                      </td>
                    </tr>
                  )}

                </>
              )}

            </tbody>
          </table>
          <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </div>
  );
}
